import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mb-progress-bar',
  templateUrl: './mb-progress-bar.component.html',
  styleUrls: ['./mb-progress-bar.component.scss']
})
export class MbProgressBarComponent implements OnInit {

  @Input() width;
  @Input() percent;
  @Input() decimals;
  @Input() class;
  @Input() label;

  constructor() { }

  ngOnInit() {
  }

  public parseInt(string) {
    return parseInt(string, 10);
  }
}
